/**
 * To be able to use icons in the assets folder in Arcgis layers, we need to use require.context.
 * This is because webpack needs to know all the assets that will be used in the application.
 * So all newly added assets that will be used in the map should be loaded using assetContext.
 */
export const assetContext = require.context('@/assets/', true, /\.svg$/)
